import Pro1_SoftwareEngineer from './Pro1_SoftwareEngineer';
import Pro2_DataScientist from './Pro2_DataScientist';
import Pro3_UIUXDesigner from './Pro3_UIUXDesigner';
import Pro4_DevOpsEngineer from './Pro4_DevOpsEngineer';
import Pro5_CybersecurityAnalyst from './Pro5_CybersecurityAnalyst';
import Pro6_FinancialAnalyst from './Pro6_FinancialAnalyst';
import Pro7_AccountantAuditor from './Pro7_AccountantAuditor';
import Pro8_InvestmentBanker from './Pro8_InvestmentBanker';
import Pro9_DigitalMarketingManager from './Pro9_DigitalMarketingManager';
import Pro10_BrandManager from './Pro10_BrandManager';
import Pro11_MedicalDoctor from './Pro11_MedicalDoctor';
import Pro12_RegisteredNurse from './Pro12_RegisteredNurse';
import Pro13_Pharmacist from './Pro13_Pharmacist';
import Pro14_CivilStructuralEngineer from './Pro14_CivilStructuralEngineer';
import Pro15_ElectricalEngineer from './Pro15_ElectricalEngineer';
import Pro16_MechanicalEngineer from './Pro16_MechanicalEngineer';
import Pro17_LawyerLegalCounsel from './Pro17_LawyerLegalCounsel';
import Pro18_ComplianceOfficer from './Pro18_ComplianceOfficer';
import Pro19_SchoolTeacher from './Pro19_SchoolTeacher';
import Pro20_UniversityLecturer from './Pro20_UniversityLecturer';
import Pro21_HotelManager from './Pro21_HotelManager';
import Pro22_ChefHeadChef from './Pro22_ChefHeadChef';
import Pro23_SalesManager from './Pro23_SalesManager';
import Pro24_RealEstateAgent from './Pro24_RealEstateAgent';
import Pro25_HRManager from './Pro25_HRManager';
import Pro26_SupplyChainManager from './Pro26_SupplyChainManager';
import Pro27_GraphicDesigner from './Pro27_GraphicDesigner';
import Pro28_ContentCreator from './Pro28_ContentCreator';
import Pro29_ExecutiveAssistant from './Pro29_ExecutiveAssistant';
import Pro30_ProjectManager from './Pro30_ProjectManager';

export const ProfessionTemplates = {
  'pro-1': { component: Pro1_SoftwareEngineer, title: 'Software Engineer' },
  'pro-2': { component: Pro2_DataScientist, title: 'Data Scientist' },
  'pro-3': { component: Pro3_UIUXDesigner, title: 'UI / UX Designer' },
  'pro-4': { component: Pro4_DevOpsEngineer, title: 'DevOps Engineer' },
  'pro-5': { component: Pro5_CybersecurityAnalyst, title: 'Cybersecurity Analyst' },
  'pro-6': { component: Pro6_FinancialAnalyst, title: 'Financial Analyst' },
  'pro-7': { component: Pro7_AccountantAuditor, title: 'Accountant / Auditor' },
  'pro-8': { component: Pro8_InvestmentBanker, title: 'Investment Banker' },
  'pro-9': { component: Pro9_DigitalMarketingManager, title: 'Digital Marketing Manager' },
  'pro-10': { component: Pro10_BrandManager, title: 'Brand Manager' },
  'pro-11': { component: Pro11_MedicalDoctor, title: 'Medical Doctor' },
  'pro-12': { component: Pro12_RegisteredNurse, title: 'Registered Nurse' },
  'pro-13': { component: Pro13_Pharmacist, title: 'Pharmacist' },
  'pro-14': { component: Pro14_CivilStructuralEngineer, title: 'Civil / Structural Engineer' },
  'pro-15': { component: Pro15_ElectricalEngineer, title: 'Electrical Engineer' },
  'pro-16': { component: Pro16_MechanicalEngineer, title: 'Mechanical Engineer' },
  'pro-17': { component: Pro17_LawyerLegalCounsel, title: 'Lawyer / Legal Counsel' },
  'pro-18': { component: Pro18_ComplianceOfficer, title: 'Compliance Officer' },
  'pro-19': { component: Pro19_SchoolTeacher, title: 'School Teacher' },
  'pro-20': { component: Pro20_UniversityLecturer, title: 'University Lecturer' },
  'pro-21': { component: Pro21_HotelManager, title: 'Hotel Manager' },
  'pro-22': { component: Pro22_ChefHeadChef, title: 'Chef / Head Chef' },
  'pro-23': { component: Pro23_SalesManager, title: 'Sales Manager' },
  'pro-24': { component: Pro24_RealEstateAgent, title: 'Real Estate Agent' },
  'pro-25': { component: Pro25_HRManager, title: 'HR Manager' },
  'pro-26': { component: Pro26_SupplyChainManager, title: 'Supply Chain Manager' },
  'pro-27': { component: Pro27_GraphicDesigner, title: 'Graphic Designer' },
  'pro-28': { component: Pro28_ContentCreator, title: 'Content Creator' },
  'pro-29': { component: Pro29_ExecutiveAssistant, title: 'Executive Assistant' },
  'pro-30': { component: Pro30_ProjectManager, title: 'Project Manager' },
};
